import { StockTransferDetailsComponent } from './stock-transfer-details.component';

export default StockTransferDetailsComponent;
